import {stateTypeDirectTable, typeSystemStats} from "../constants/api";
import {processServerError} from "./utilities/ServiceError";
import {APIConnector} from "./api/APIConnector";
import {genericError} from "../models/GenericError";

interface TabCount{
    tabCount:number
}

interface QueryHeaders {
    type: string;
    statType: string;
    tableName: string;
    filterBySiteids?: string[];
    pathToSite?: string;
    customFilters?: string;
}
const apiConnector = new APIConnector();

export const getTabCount = async (tableName: string, pathToSite?: string, siteIds: string[] = [""], customFilters: { [key: string]: string } | {} = {}): Promise<TabCount> => {
    try{
        const url = '';
        const headers:QueryHeaders = {
            type:typeSystemStats,
            statType:stateTypeDirectTable,
            tableName:tableName,
            filterBySiteids:siteIds,
            customFilters: JSON.stringify(customFilters),
        }

    // Only add pathToSite if it's provided
        if(pathToSite){
            headers.pathToSite = pathToSite;
        }

        const response = await apiConnector.fetchData(url,true,headers);
        const jsonResponse = await response.json();

        return new Promise((resolve, reject) => {
            if(jsonResponse.errors){
                return reject({status:response.status,message:genericError});
            }

            const tabCount:TabCount = {
                tabCount:jsonResponse['totals']['countAll']
            }

            return resolve(tabCount);
        })
    }catch (error){
        return new Promise((resolve, reject) => {
            reject(processServerError(error));
        });
    }

}
